import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class Kiitos extends Component {
componentDidMount() {
    document.title = "Kiitos yhteydenotostasi - mitattu.fi";
  }

  render() {
    return (
      <>
        <h1>Kiitos yhteydenotostasi!</h1>
        <p>Jos jätit yhteystietosi, niin palaan asiaan piakkoin.</p>
        <p className="thanks">
          <Link className="button" to="/">
            Etusivulle
          </Link>
        </p>
      </>
    );
  }
}
